import { Pipe, PipeTransform } from '@angular/core';
import { ReportLabelsService } from '../../features/manage-settings/report-labels/report-labels.service';
import { LabelKey } from '../models/report-labels.model';
import { Observable, of } from 'rxjs';

@Pipe({
  name: 'reportLabel',
  standalone: true,
})
export class ReportLabelPipe implements PipeTransform {
  constructor(private reportLabelsService: ReportLabelsService) {}

  transform(key: LabelKey | string): Observable<string> {
    if (!key) return of('');
    return this.reportLabelsService.getLabelValue(key);
  }
}
